module.exports = __webpack_public_path__ + "static/media/tech.bd3e6775.png";